<template>
  <el-drawer :title="isedit ? '编辑员工' : '新增员工'" :visible.sync="dialogshow" :show-close="false" :destroy-on-close="true"
    :wrapperClosable="false" direction="rtl" ref="drawer" :size="getViewWidth()">
    <div class="dialogshow">
      <div class="dialoForm-content">
        <el-form class="dialoForm-form" ref="createform" :model="createform" label-width="120px" :rules="rules"
          style="width: 95%">
          <el-form-item label="启用状态：">
            <el-switch v-model="createform.EnableMark"></el-switch>
          </el-form-item>
          <el-form-item label="员工性质：">
            <el-checkbox label="收费员" v-model="createform.CollertorMark"></el-checkbox>
            <el-checkbox label="后台用户" v-model="createform.ManageMark"></el-checkbox>
          </el-form-item>
          <el-form-item label="账号：" prop="EmpCode">
            <el-input v-model="createform.EmpCode" maxlength="20" show-word-limit autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="姓名：" prop="EmpName">
            <el-input v-model="createform.EmpName" maxlength="10" show-word-limit autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item v-if="!isedit" label="登录密码：" prop="Password">
            <el-input v-model="createform.Password" show-password show-word-limit maxlength="32"
              autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item v-if="isedit" label="登录密码：">
            <el-input v-model="createform.Password" placeholder="输入密码则修改当前密码，不输入不修改" show-password show-word-limit
              maxlength="32" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="createform.MobilePhone" show-word-limit maxlength="11" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item v-if="createform.ManageMark && (ProductId == 2||ProductId==3)" label="免单二维码：">
            <el-switch style="width: 80px" v-model="createform.FreeQrcodeMark"></el-switch>
            开启后小程序端可生成免单二维码
          </el-form-item>
          <el-form-item v-if="createform.ManageMark && (ProductId == 2||ProductId==3)" label="道闸控制：">
            <el-switch style="width: 80px" v-model="createform.BarrierGateCmdMark"></el-switch>
            开启后小程序端可手动控制道闸开启
          </el-form-item>
          <el-form-item label="路段绑定：">
            <el-switch style="width: 80px" v-model="createform.BindSectionMark"></el-switch>
            <el-select v-if="createform.BindSectionMark" style="width: 300px" :multiple="true"
              v-model="createform.SectionIds" placeholder="请选择可收费或查看报表的路段">
              <el-option v-for="item in sectionlist" :key="item.Id" :label="item.SectionName"
                :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
     
          <el-form-item v-if="createform.CollertorMark" label="全部出场权限：">
            <el-switch style="width: 80px" v-model="createform.AllOutMark"></el-switch>
            开启后在收费端允许操作全部出场
          </el-form-item>
          <el-form-item v-if="createform.CollertorMark" label="跑单权限：">
            <el-switch style="width: 80px" v-model="createform.PTMark"></el-switch>
            开启后在收费端允许操作跑单
          </el-form-item>
          <el-form-item v-if="createform.CollertorMark" label="出场修改时间：">
            <el-switch style="width: 80px" v-model="createform.editendtimemark"></el-switch>
            开启后在收费端出场时允许修改出场时间
          </el-form-item>
          <el-form-item v-if="createform.CollertorMark" label="收费金额修改：">
            <el-switch style="width: 80px" v-model="createform.editamountmark"></el-switch>
            开启后在收费端允许修改收费金额
          </el-form-item>
          <el-form-item v-if="false" label="权限复制：">
            <el-select style="width: 150px" v-model="authtype.defaultvalue" placeholder="请选择">
              <el-option v-for="item in authtype.options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-if="authtype.defaultvalue === 1" style="width: 200px" v-model="rolelistvalue"
              @change="rolechange" placeholder="请选择">
              <el-option v-for="item in rolelist" :key="item.Id" :label="item.RoleName" :value="item.Id">
              </el-option>
            </el-select>
            <el-select v-if="authtype.defaultvalue === 2" style="width: 200px" v-model="emplistvalue"
              @change="empchange" placeholder="请选择">
              <el-option v-for="item in emplist" :key="item.Id" :label="item.EmpName" :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-collapse v-model="activeName" style="margin-left: 10px">
          <el-collapse-item v-if="createform.ManageMark" title="后台权限" name="2">
            <div style="
                margin: 10px 10px 10px 10px;
                border-bottom: 1px solid #e8e8e8;
              " :key="index" v-for="(item, index) in createform.authdetails.webauthlist">
              <el-checkbox :indeterminate="item.indeterminate" v-model="item.AllAuthMark"
                @change="handleCheckAllChange(item)">{{ item.AuthName }}</el-checkbox>
              <div style="margin: 10px 10px 10px 0px">
                <el-checkbox-group v-model="item.haschildren2" @change="handleCheckedChange(item)">
                  <el-checkbox :key="i" v-for="(ci, i) in item.children" :label="ci.AuthId">{{ ci.AuthName
                    }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="dialoForm-footer">
        <el-button @click="cancel" style="width: 100px">取 消</el-button>
        <el-button style="width: 100px" type="primary" @click="save()">保 存</el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { createemp, editemp, queryemp, getempbyid } from "@/api/employee";
import { query as querysectionlist } from "@/api/section";
import { queryrole, getrolebyid } from "@/api/role";
export default {
  name: "addemp",
  props: {
    isedit: {
      required: true,
      type: Boolean,
    },
    dialogshow: {
      required: true,
      type: Boolean,
    },
    editform: {
      required: true,
      type: Object,
    },
  },
  computed: {
    childdialogshow: {
      get() {
        return this.dialogshow;
      },
      set(val) {
        this.$emit("update:dialogshow", val);
      },
    },
    createform: {
      get() {
        return this.editform;
      },
    },
  },
  data() {
    return {
      ProductId: 1,
      sectionlist: [],
      emplist: [],
      querysectionlist: [],
      emplistvalue: "",
      rolelist: [],
      rolelistvalue: "",
      activeName: ["1", "2"],
      authtype: {
        defaultvalue: 1,
        options: [
          { value: 1, label: "角色" },
          { value: 2, label: "员工" },
        ],
      },
      rules: {
        EmpName: [
          { required: true, message: "员工姓名不能为空", trigger: "change" },
        ],
        EmpCode: [
          { required: true, message: "员工账号不能为空", trigger: "change" },
        ],
        Password: [
          { required: true, message: "员工密码不能为空", trigger: "change" },
          {
            max: 32,
            message: "员工密码长度不超过32个字，请重新输入",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.ProductId = window.localStorage.ProductId;
    if (this.isedit) {
      this.createform.authdetails.webauthlist.forEach((item) => {
        //如果有值的情况下，要把对象放到数组2中，因为设想的情况就是从接口拿到就是一个对象
        item.haschildren2 = [];
        if (item.haschildren.length > 0) {
          item.haschildren.forEach((child) => {
            item.haschildren2.push(child.AuthId);
          });
        }
      });
    } else {
      this.createform.authdetails.webauthlist.forEach((item) => {
        //如果有值的情况下，要把对象放到数组2中，因为设想的情况就是从接口拿到就是一个对象
        item.haschildren2 = [];
        if (item.children.length > 0) {
          item.children.forEach((child) => {
            item.haschildren2.push(child.AuthId);
          });
        }
      });
    }
    querysectionlist({
      pageSize: 10000,
    }).then((res) => {
      this.sectionlist = res.data;
    });
    queryrole({
      pageIndex: 1,
      pageSize: 10000,
      orderColumn: "",
      orderbyasc: false,
      querymodel: {
        keyword: "",
      },
    }).then((res) => {
      this.rolelist = res.data;
    });
    queryemp({
      pageIndex: 1,
      pageSize: 10000,
      orderColumn: "",
      orderbyasc: false,
      querymodel: {
        EnableMark: -1,
        ShopMark: -1,
        keyword: "",
      },
    }).then((res) => {
      this.emplist = res.data;
    });
  },
  methods: {
    radnum() {
      var mm = Math.random();
      var six = "";
      if (mm > 0.1) {
        six = Math.round(mm * 1000000);
      } else {
        mm += 0.1;
        six = Math.round(mm * 1000000);
      }
      this.createform.AuthQRCode = six;
    },
    rolechange(value) {
      getrolebyid({ id: value }).then((res) => {
        this.editform.authdetails = {};
        this.editform.authdetails.webauthlist = res.webauthlist;
        // this.editform.authdetails.saleauthlist = res.saleauthlist;
      });
    },
    empchange(value) {
      getempbyid({ id: value }).then((res) => {
        this.editform.authdetails = {};
        this.editform.authdetails.webauthlist = res.webauthlist;
        // this.editform.authdetails.saleauthlist = res.saleauthlist;
      });
      this.editform.authdetails.webauthlist.forEach((item) => {
        item.AllAuthMark = true;
        item.indeterminate = false;
        item.children.forEach((child) => {
          child.AuthValue = true;
          item.haschildren.push(child);
        });
      });
      this.$forceUpdate();
    },
    //全选
    handleCheckAllChange(row) {
      //后台权限
      if (row.AuthGroup === 1) {
        this.createform.authdetails.webauthlist.forEach((item) => {
          this.handlegrouprow(item, row);
        });
      }
      // //收银权限
      // if (row.AuthGroup === 2) {
      //   this.createform.authdetails.saleauthlist.forEach((item) => {
      //     this.handlegrouprow(item, row);
      //   });
      // }
    },
    handlegrouprow(item, row) {
      if (item.AuthId == row.AuthId) {
        if (item.AllAuthMark) {
          item.haschildren2 = [];
          item.children.forEach((child) => {
            item.haschildren2.push(child.AuthId);
          });
        } else {
          item.haschildren2 = [];
        }
        item.indeterminate = false;
      }
      this.$forceUpdate();
    },
    //单选
    handleCheckedChange(row) {
      //后台权限
      if (row.AuthGroup === 1) {
        this.createform.authdetails.webauthlist.forEach((item) => {
          this.handlerow(item, row);
        });
      }
      // //收银权限
      // if (row.AuthGroup === 2) {
      //   this.createform.authdetails.saleauthlist.forEach((item) => {
      //     this.handlerow(item, row);
      //   });
      // }
    },
    handlerow(item, row) {
      if (item.AuthId === row.AuthId) {
        if (row.children.length === row.haschildren2.length) {
          item.AllAuthMark = true;
          item.indeterminate = false;
        }
        if (row.haschildren2.length === 0) {
          item.indeterminate = false;
          item.AllAuthMark = false;
        }
        if (
          row.haschildren2.length !== 0 &&
          row.children.length != row.haschildren.length
        ) {
          item.indeterminate = true;
        }
      }
      this.$forceUpdate();
    },
    getallchecked() {
      var allcheckednode = new Array();
      this.createform.authdetails.webauthlist.forEach((item) => {
        if (item.haschildren2.length > 0) {
          var BtnIdList = ",";
          item.haschildren2.forEach((clild) => {
            if (BtnIdList.indexOf("," + clild + ",") == -1) {
              BtnIdList += clild + ",";
            }
          });
          allcheckednode.push({
            AuthId: item.AuthId,
            AuthGroup: 1,
            AuthKey: "",
            BtnIdList: BtnIdList.substr(1, BtnIdList.length - 2),
          });
        }
      });
      return allcheckednode;
    },
    save() {
      if (!(this.createform.ManageMark || this.createform.CollertorMark)) {
        this.$message({
          message: "请至少选择一种员工性质！",
          type: "error",
        });
        return false;
      }
      this.$refs.createform.validate((valid) => {
        if (valid) {
          var savecreateform = JSON.parse(JSON.stringify(this.createform));
          savecreateform.authdetails = this.getallchecked();
          savecreateform.PhotoImgUrl = "";
          savecreateform.remark = "";
          if (!this.isedit) {
            createemp(savecreateform).then((res) => {
              this.$message({
                message: "新增成功！",
                type: "success",
              });
              this.dialogshow = false;
              this.childdialogshow = false;
              this.$emit("savecomplete");
            });
          } else {
            editemp(savecreateform).then((res) => {
              this.$message({
                message: "保存成功！",
                type: "success",
              });
              this.dialogshow = false;
              this.childdialogshow = false;
              this.$emit("savecomplete");
            });
          }
        }
      });
    },
    cancel() {
      this.$emit("cancelcomplete");
    },
  },
};
</script>